export enum DebugSectionId {
  Navigation = 'Navigation',
  Game = 'GameScene',
  Board = 'Board',
  MainMenu = 'MainMenu',
  Editor = 'EditorScene',
  SplitTest = 'SplitTest',
  Resources = 'Resources',
  State = 'State',
  Tournaments = 'Tournaments',
  Time = 'Time',
  Tools = 'Tools',
  Solver = 'Solver',
  PlatformCheat = 'PlatformCheat',
}
